/*!
 * @license
 * Copyright 2019 Alfresco, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export { VariablesModule } from './variables.module';
export { VariablesComponent } from './variables.component';
export { VariableValuePipe } from './properties-viewer/variable-value.pipe';
export * from './properties-viewer/value-type-inputs/value-type-inputs';
export { PropertiesViewerIntegerInputComponent } from './properties-viewer/value-type-inputs/integer-input.component';
export { PropertiesViewerStringInputComponent } from './properties-viewer/value-type-inputs/string-input.component';
export { PropertiesViewerBooleanInputComponent } from './properties-viewer/value-type-inputs/boolean-input.component';
export { PropertiesViewerDateInputComponent } from './properties-viewer/value-type-inputs/date-input.component';
export { PropertiesViewerJsonInputComponent } from './properties-viewer/value-type-inputs/json-input.component';
export { PropertiesViewerFileInputComponent } from './properties-viewer/value-type-inputs/file-input.component';
export { PropertiesViewerDateTimeInputComponent } from './properties-viewer/value-type-inputs/date-time-input.component';
export { PropertiesViewerArrayInputComponent } from './properties-viewer/value-type-inputs/array-input.component';
